import Vue from 'vue';

export default {
    extend() {
        const vue = Vue;
        const originalVisibleFns = vue.options.components.ElSelect.options.watch.visible;
        const originalMountedFns = vue.options.components.ElSelect.options.mounted;

        const extensions = {
            props: {
                popperAppendToBody: {
                    type: Boolean,
                    default() {
                        return !this.$client.isMobile;
                    },
                },
            },
            mounted() {
                originalMountedFns.forEach((fn) => {
                    fn.call(this);
                });
                this.removeReadOnly();
            },
            watch: {
                visible(val) {
                    originalVisibleFns.forEach((fn) => {
                        fn.call(this, val);
                    });
                    this.removeReadOnly();
                },
            },
            methods: {
                removeReadOnly() {
                    this.$nextTick(() => {
                        if (!this.multiple) {
                            const input = this.$el.querySelector('.el-input__inner');
                            input.removeAttribute('readonly');
                        }
                    });
                },
                resetInputWidth: function resetInputWidth() {
                    this.inputWidth = this.$refs.reference
                        ? this.$refs.reference.$el.getBoundingClientRect().width
                        : this.inputWidth;
                },
            },
        };

        const defaultOptions = vue.options.components.ElSelect.options;
        vue.options.components.ElSelect.options = Vue.util.mergeOptions(defaultOptions, extensions);
    },
};
